"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPreImmunisation = createPreImmunisation;
const utils_1 = require("../../../events/utils");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const combinedOrganTransplantation_1 = require("../../../forms/ktx/basic-registration-data/clinical-data/pre-immunisation/combinedOrganTransplantation");
const previousOtherOrganTransplantation_1 = require("../../../forms/ktx/basic-registration-data/clinical-data/pre-immunisation/previousOtherOrganTransplantation");
const transfusion_1 = require("../../../forms/ktx/basic-registration-data/clinical-data/pre-immunisation/transfusion");
const messages = {
    renal: {
        id: "ktx.dashboard.pre_immunisation",
        defaultMessage: "Előzetes immunizáltság"
    },
    previousOtherOrganTransplantation: {
        id: "ktx.dashboard.pre_immunisation.previous_other_organ_transplantation",
        defaultMessage: "Korábbi szerv- vagy szövet transzplantáció"
    },
    transfusion: {
        id: "ktx.dashboard.pre_immunisation.transfusion",
        defaultMessage: "Transzfúzió"
    },
    combinedOrganTransplantation: {
        id: "ktx.dashboard.combined_organ_transplantation",
        defaultMessage: "Kombinált szervtranszplantációs javaslat"
    },
    pregnanciesAndChildren: {
        id: "ktx.dashboard.pregnancies_and_children.title",
        defaultMessage: "Terhesség"
    },
    numberOfPregnancies: {
        id: "ktx.dashboard.pregnancies_and_children.pregnancies",
        defaultMessage: "Terhességek száma"
    },
    numberOfChildren: {
        id: "ktx.dashboard.pregnancies_and_children.children",
        defaultMessage: "Gyerekek száma"
    }
};
function createPreImmunisation(intl, options) {
    const previousOtherOrganTransplantation = createPreviousOtherOrganTransplantation(intl, options);
    const transfusion = createTransfusion(intl, options);
    const combinedOrganTransplantation = createCombinedOrganTransplantation(intl, options);
    const pregnanciesAndChildren = createPregnanciesAndChildren(intl, options);
    const content = (0, shared_1.createSectionContent)([
        previousOtherOrganTransplantation,
        combinedOrganTransplantation,
        transfusion,
        pregnanciesAndChildren
    ]);
    return (0, shared_1.createSection)(intl, { label: messages.renal, content });
}
function createPreviousOtherOrganTransplantation(intl, { events }) {
    const { formatMessageMap, formatDate } = intl;
    const relevantEvents = (0, utils_1.findEventsByQuery)(events, queries_1.preImmunisationQueries.previousOtherOrganTransplantation);
    const m = {
        ...previousOtherOrganTransplantation_1.previousOtherOrganTransplantationTypeMessages,
        ...previousOtherOrganTransplantation_1.hasPreviousOtherOrganTransplantationMessages
    };
    const list = relevantEvents
        .map(event => {
        const { timestamp, origin } = event;
        const formattedTimestamp = formatDate(timestamp, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        const items = [];
        items.push({
            type: "list-item",
            value: event.value in m
                ? formatMessageMap(m, event.value)
                : event.value // long text
        });
        return {
            type: "list",
            attachments: (0, utils_1.mapEventsToAttachments)(event),
            timestamp: event.timestamp,
            label: formattedTimestamp,
            origin,
            items
        };
    })
        .sort(shared_1.compareByTimestamp);
    const content = (0, shared_1.createGroupContent)(list);
    return (0, shared_1.createGroup)(intl, {
        label: messages.previousOtherOrganTransplantation,
        content
    });
}
function createTransfusion(intl, { events }) {
    const { formatMessageMap, formatDate } = intl;
    const relevantEvents = (0, utils_1.findEventsByQuery)(events, queries_1.preImmunisationQueries.transfusion);
    const list = relevantEvents
        .map(event => {
        const { timestamp, origin } = event;
        const formattedTimestamp = formatDate(timestamp, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        const items = [];
        items.push({
            type: "list-item",
            value: event.value.transfusionOccurred in
                transfusion_1.transfusionOccurredMessages
                ? formatMessageMap(transfusion_1.transfusionOccurredMessages, event.value.transfusionOccurred)
                : event.value.transfusionOccurred
        });
        return {
            type: "list",
            attachments: (0, utils_1.mapEventsToAttachments)(event),
            timestamp: event.timestamp,
            label: formattedTimestamp,
            origin,
            items
        };
    })
        .sort(shared_1.compareByTimestamp);
    const content = (0, shared_1.createGroupContent)(list);
    return (0, shared_1.createGroup)(intl, { label: messages.transfusion, content });
}
function createCombinedOrganTransplantation(intl, { events }) {
    const { formatMessageMap, formatDate } = intl;
    const relevantEvents = (0, utils_1.findEventsByQuery)(events, queries_1.preImmunisationQueries.combinedOrganTransplantation);
    const list = relevantEvents
        .map(event => {
        const { timestamp, origin } = event;
        const formattedTimestamp = formatDate(timestamp, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        const items = [];
        if (event.value.organTransplantation) {
            for (const t of event.value.organTransplantation) {
                items.push({
                    type: "list-item",
                    value: t in combinedOrganTransplantation_1.organTransplantationMessages
                        ? formatMessageMap(combinedOrganTransplantation_1.organTransplantationMessages, t)
                        : t
                });
            }
        }
        else if (event.value.hasOrganTransplantation) {
            items.push({
                type: "list-item",
                value: formatMessageMap(combinedOrganTransplantation_1.hasOrganTransplantationMessages, event.value.hasOrganTransplantation)
            });
        }
        return {
            type: "list",
            attachments: (0, utils_1.mapEventsToAttachments)(event),
            timestamp: event.timestamp,
            label: formattedTimestamp,
            origin,
            items
        };
    })
        .sort(shared_1.compareByTimestamp);
    const content = (0, shared_1.createGroupContent)(list);
    return (0, shared_1.createGroup)(intl, {
        label: messages.combinedOrganTransplantation,
        content
    });
}
function createPregnanciesAndChildren({ formatMessage }, { events }) {
    const event = (0, utils_1.findLastEventByQuery)(events, queries_1.preImmunisationQueries.pregnanciesAndChildren);
    if (event === undefined) {
        return undefined;
    }
    const numberOfPregnancies = {
        type: "list-item",
        label: formatMessage(messages.numberOfPregnancies),
        value: `${event.value.numberOfPregnancies}`
    };
    const numberOfChildren = {
        type: "list-item",
        label: formatMessage(messages.numberOfChildren),
        value: `${event.value.numberOfChildren}`
    };
    const items = [numberOfPregnancies, numberOfChildren];
    const { origin } = event;
    return {
        type: "list",
        attachments: (0, utils_1.mapEventsToAttachments)(event),
        origin,
        label: formatMessage(messages.pregnanciesAndChildren),
        items
    };
}
